import ImageCaption from './ImageCaption';

export default ImageCaption;
